import angular from 'angular';
import find from 'lodash/find';


class AddMullionService {
    constructor(windowDimensionsService, sashesService, $injector, $rootScope) {
        this.windowDimensionsService = windowDimensionsService;
        this.sashesService = sashesService;
        this.$injector = $injector;
        this.$rootScope = $rootScope;
        this.dividerSize = [];
        this.mullionSize = [];
        this.systemAddedDividers = {
            horizontal: 0,
            vertical: 0
        };
        //this.$rootScope.$on('dimensionsChangeEvent', () => this.recalculateDividers(false));
    }

    requireMullions() {
        if (this.systemAddedDividers.horizontal + this.systemAddedDividers.vertical > 0) {
            return true;
        }
        return false;
    }

    addSystemDivider(direction) {
        this.systemAddedDividers[direction]++;
    }

    removeSystemDivider(direction) {
        if (this.systemAddedDividers[direction] === 0) {
            return false;
        }
        this.systemAddedDividers[direction]--;
        return true;
    }

    addDivider(direction) {
        // this.mullionSetup = {};
        // this.sashesService.setup = {};
        this.windowDimensionsService.setIsSplitHorDiv(true);

        if (direction === 'vertical') {
            this.sashesService.dividersVert++;
        } else {
            this.sashesService.dividersHor++;
        }
        this.updateDividers();
    }

    addMullion(direction) {
        // this.mullionSetup = {};
        // this.sashesService.setup = {};
        if (direction === 'vertical') {
            this.sashesService.mullionsVert++;
        } else {
            this.sashesService.mullionsHor++;
        }
        this.updateDividers();
    }

    resetGrill() {
        const dataService = this.$injector.get('dataService');
        dataService.data.data[0].attributes.grill = null;
        dataService.data.data[0].relationships.glazingBar.data.id = null;
        this.selectedGrill = null;
        this.windowDimensionsService.blockMullions = false;
        this.windowDimensionsService.setGrill(null);
    }

    setMullionSetup(mullionSetup, refreshPrice = true) {
        const dataService = this.$injector.get('dataService');
        dataService.userAddedDivider = true;

        this.resetGrill();
        this.selectedGrill = mullionSetup.id;
        this.windowDimensionsService.setGrill(mullionSetup.id);
        this.sashesService.resetSashes();
        this.sashesService.resetMullions();
        this.sashesService.dividersVert = mullionSetup.data.verticalDividers;
        this.sashesService.dividersHor = mullionSetup.data.horizontalDividers;
        this.setMullionsForMullionSetups(mullionSetup.id);
        this.updateDividers(refreshPrice);
        this.selectedGrill = mullionSetup.id;
        this.windowDimensionsService.setGrill(mullionSetup.id);

        dataService.updateSelectedOptions('glazingBar', [this.selectedGrill], 'glazingBar', false);
        this.sashesService.updateSashesDimensions();
        dataService.data.data[0].attributes.grill = mullionSetup;
        this.windowDimensionsService.blockMullions = true;
    }

    resetBottomPanel() {
        this.bottomPanel = this.windowDimensionsService.getBottomPannel();
        this.windowDimensionsService.setBottomPannel(this.windowDimensionsService.height);
    }

    setBottomPannel() {
        this.windowDimensionsService.setBottomPannel(this.bottomPanel);
    }

    updateDividers(refreshPrice = true) {
        this.resetGrill();
        this.recalculateDividers(refreshPrice);
    }

    recalculateDividers(refreshPrice = true) {
        this.sashesService.resetSashes();
        this.resetBottomPanel();
        this.setDividers(refreshPrice);
        this.updateMullions(refreshPrice);
    }

    setDividers(refreshPrice = true) {
        const dividersVert = this.sashesService.dividersVert;
        const dividersHor = this.sashesService.dividersHor;
        const maxBarsVert = this.windowDimensionsService.maxBarsVert;
        const maxBarsHor = this.windowDimensionsService.maxBarsHor;
        const mullionsVert = this.sashesService.mullionsVert;
        const mullionsHor = this.sashesService.mullionsHor;

        if (dividersVert == 0 && dividersHor == 0) {
            this.sashesService.dividersService.resetDividers();
        }
        if (dividersVert > maxBarsVert - mullionsVert) {
            this.sashesService.dividersVert = maxBarsVert - mullionsVert;
        }
        if (dividersHor > maxBarsHor - mullionsHor) {
            this.sashesService.dividersHor = maxBarsHor - mullionsHor;
        }
        for (let i = 0; i < this.sashesService.dividersVert; ++i) {
            this.sashesService.addSashDivider('vertical');
        }
        for (let i = 0; i < this.sashesService.dividersHor; ++i) {
            this.sashesService.addSashDivider('horizontal');
        }
        this.updateMullions(refreshPrice);
    }

    updateMullions(refreshPrice = true) {
        this.sashesService.resetMullions();
        let sendPrice = true;

        const dividersVert = this.sashesService.dividersVert;
        const dividersHor = this.sashesService.dividersHor;
        const maxBarsVert = this.windowDimensionsService.maxBarsVert;
        const maxBarsHor = this.windowDimensionsService.maxBarsHor;
        const mullionsVert = this.sashesService.mullionsVert;
        const mullionsHor = this.sashesService.mullionsHor;

        if (mullionsVert >= maxBarsVert - dividersVert) {
            sendPrice = false;
            this.sashesService.mullionsVert = maxBarsVert - dividersVert;
        }
        if (mullionsHor >= maxBarsHor - dividersHor) {
            sendPrice = false;
            this.sashesService.mullionsHor = maxBarsHor - dividersHor;
        }
        for (let i = 0; i < this.sashesService.mullionsVert; ++i) {
            this.sashesService.addMullions('vertical');
        }
        for (let i = 0; i < this.sashesService.mullionsHor; ++i) {
            this.sashesService.addMullions('horizontal');
        }
        this.sashesService.updateSashesDimensions();
        this.selectedDividerSize = find(this.dividerSize, ['id', this.$injector.get('dataService').getSelectedOptionId('dividerSize')]);

        if (!this.$injector.get('dataService').data.data[0].attributes.isWindowDoorOrPairDoors) {
            this.$injector.get('dataService').updateHandleSide();
        }
        this.setBottomPannel();

        if (this.windowDimensionsService.isBottomPannel()) {
            this.sashesService.updateSashesDimensions();
        }
        this.$injector.get('dataService').jsonService.getJson();
        this.windowDimensionsService.noNewMullions = false;

        if (refreshPrice) {
            this.$injector.get('dataService').setPrice();
        }
    }

    setMullionsForMullionSetups(id) {
        const config = {
            1: {
                horizontal: 1,
                vertical: 1,
            },
            2: {
                horizontal: 2,
                vertical: 1,
            },
            3: {
                horizontal: 0,
                vertical: 0,
            },
            4: {
                horizontal: 2,
                vertical: 0,
            },
            5: {
                horizontal: 1,
                vertical: 0,
            },
            6: {
                horizontal: 0,
                vertical: 0,
            },
            7: {
                horizontal: 0,
                vertical: 0,
            },
            8: {
                horizontal: 1,
                vertical: 0,
            },
            9: {
                horizontal: 0,
                vertical: 0,
            },
            10: {
                horizontal: 1,
                vertical: 0,
            },
            11: {
                horizontal: 2,
                vertical: 0,
            },
            12: {
                horizontal: 3,
                vertical: 1,
            },
            13: {
                horizontal: 4,
                vertical: 1,
            },
            14: {
                horizontal: 1,
                vertical: 1,
            },
            15: {
                horizontal: 1,
                vertical: 0,
            },
            16: {
                horizontal: 3,
                vertical: 0,
            },
            17: {
                horizontal: 4,
                vertical: 0,
            },
            18: {
                horizontal: 0,
                vertical: 0,
            },
            19: {
                horizontal: 0,
                vertical: 0,
            },
            20: {
                horizontal: 1,
                vertical: 1,
            },
        };
        if (angular.isDefined(config[id])) {
            this.sashesService.mullionsHor = config[id].horizontal;
            this.sashesService.mullionsVert = config[id].vertical;
        } else {
            this.sashesService.mullionsHor = 0;
            this.sashesService.mullionsVert = 0;
        }
    }

}

AddMullionService.$inject = [
    'windowDimensionsService',
    'sashesService',
    '$injector',
    '$rootScope'
];

export default angular.module('addMullionService', [])
    .service('addMullionService', AddMullionService)
    .name;